import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import { OperationColumnsEnum } from './operation-columns.enum';

export function getTableColumns(): TableColumn[] {
  return [
    {
      name: OperationColumnsEnum.Operation,
      position: 0,
      selected: true,
      text: TextKeys.operation.title,
    },
    {
      name: OperationColumnsEnum.Note,
      position: 1,
      selected: true,
      text: TextKeys.operation.note,
    },
    {
      name: OperationColumnsEnum.CostCenterNumber,
      position: 2,
      selected: true,
      text: TextKeys.costCenter.numberShort,
    },
    {
      name: OperationColumnsEnum.CostCenterName,
      position: 3,
      selected: true,
      text: TextKeys.costCenter.title,
    },
  ];
}
